/**
 * Utility functions for import validation
 */

/**
 * Validates if a string is a valid URL
 */
export const validateUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

/**
 * Validates if text is sufficient for recipe import
 */
export const validateRecipeText = (text: string): { isValid: boolean; error?: string } => {
  if (!text.trim()) {
    return { isValid: false, error: "Please enter your recipe text" };
  }

  return { isValid: true };
};
